/**
 * Equipment category types for the equipment catalog.
 */
export var EquipmentCategory;
(function (EquipmentCategory) {
    EquipmentCategory["FREE_WEIGHTS"] = "FREE_WEIGHTS";
    EquipmentCategory["MACHINE"] = "MACHINE";
    EquipmentCategory["CABLE"] = "CABLE";
    EquipmentCategory["CARDIO"] = "CARDIO";
    EquipmentCategory["BODYWEIGHT"] = "BODYWEIGHT";
    EquipmentCategory["ACCESSORIES"] = "ACCESSORIES";
})(EquipmentCategory || (EquipmentCategory = {}));
/**
 * Difficulty level for equipment usage.
 */
export var EquipmentDifficultyLevel;
(function (EquipmentDifficultyLevel) {
    EquipmentDifficultyLevel["BEGINNER"] = "BEGINNER";
    EquipmentDifficultyLevel["INTERMEDIATE"] = "INTERMEDIATE";
    EquipmentDifficultyLevel["ADVANCED"] = "ADVANCED";
})(EquipmentDifficultyLevel || (EquipmentDifficultyLevel = {}));
